import { React, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import { Styled, DatePickerY, DisabledButtonStyle } from "../../pageStyled";
import { DatePicker } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tooltip,
} from "antd";
import { HaberForm } from "../../styledElements";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import moment from "moment";
import { saveUploadedCustomers } from "../../../Services/uploadServices";
import {
  getCustomersForConfiguration,
} from "../../../Services/customerServices";

import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { Country, State } from "country-state-city";
import { capital_letter } from "../../../Utils/helper/helper";

const { TextArea } = Input;

const CustomerValidation = (props) => {
  const userTypeData = [
    { label: "Dealer", value: "dealer" },
    { label: "Direct Customer", value: "direct_customer" },
  ];
  const location = useLocation();
  const history = useNavigate();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [customers, setCustomers] = useState(
    location.state.action.data.customers
  );
  const [totalRecords, setTotalRecords] = useState(
    location.state.action.data.customers
  );
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [show, setShow] = useState(false);
  const rowCount = useRef(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const { height, width } = useWindowDimensions();
  const [rerendering, setRerendering] = useState(false);
  const [aliasList, setAliasList] = useState();
  const [primaryContactError, setPrimaryContactError] = useState([]);

  useEffect(() => {
    getCustomersForConfiguration().then((response) => {
      const list = response.map((customer) => customer.alias);
      setAliasList(list);
    });
    let changedCustomer = [];
    for (let index = 0; index < customers.length; index++) {
      let customer = customers[index];
      customer["key"] = `${customer.customer.name + index}`;
      const countries = Country.getAllCountries();
      customer.customer["countries"] = countries;
      customer.customer["delivery_countries"] = countries;
      const filteredCountry = countries.filter(
        (country) =>
          country.name.toUpperCase() === customer.customer.country.toUpperCase()
      );
      const filteredDelCountry = countries.filter(
        (country) =>
          country.name.toUpperCase() === customer.customer.delivery_country.toUpperCase()
      );
      if (filteredCountry.length) {
        customer.customer.country = filteredCountry[0].name;
        customer.customer["isoCode"] = filteredCountry[0].isoCode;
        const states = State.getStatesOfCountry(filteredCountry[0].isoCode);
        customer.customer["states"] = states;
        const filteredState = states.filter(
          (state) =>
            state.name.toUpperCase() === customer.customer.state.toUpperCase()
        );
        if (filteredState.length) {
          customer.customer.state = filteredState[0].name;
        } else {
          customer.error_count = customer.error_count + 1;
          customer.errors["state"] = "State is not found";
        }
        if (customer.customer.same_as_office_address) {
          customer.customer.delivery_country = filteredCountry[0].name;
          customer.customer["delivery_states"] = states;
          if (filteredState.length) {
            customer.customer.delivery_state = filteredState[0].name;
          }
        } 
        // else {
        //   customer.customer["delivery_states"] = [];
        // }
      } else {
        customer.error_count = customer.error_count + 1;
        customer.errors["country"] = "Country is not found";
        customer.customer["isoCode"] = "IN";
        customer.customer["states"] = [];
        // customer.customer["delivery_states"] = [];
      }

      if(filteredDelCountry.length){
        customer.customer.delivery_country = filteredDelCountry[0].name;
        customer.customer["isoCode"] = filteredDelCountry[0].isoCode;
        const statesData = State.getStatesOfCountry(filteredDelCountry[0].isoCode);
        customer.customer["delivery_states"] = statesData;
        const filteredDelState = statesData.filter(
          (state) =>
            state.name.toUpperCase() === customer.customer.delivery_state.toUpperCase()
        );
        if (filteredDelState.length) {
          customer.customer.delivery_state = filteredDelState[0].name;
        } else {
          customer.error_count = customer.error_count + 1;
          customer.errors["delivery_state"] = "State is not found";
        }
        if (customer.customer.same_as_office_address) {
          customer.customer.delivery_country = filteredDelCountry[0].name;
          customer.customer["delivery_states"] = statesData;
          if (filteredDelState.length) {
            customer.customer.delivery_state = filteredDelState[0].name;
          }
        } 
        // else {
        //   customer.customer["delivery_states"] = [];
        // }
      } else {
        customer.error_count = customer.error_count + 1;
        customer.errors["delivery_country"] = "Country is not found";
        customer.customer["isoCode"] = "IN";
        // customer.customer["delivery_state"] = [];
        customer.customer["delivery_states"] = [];
      }

      changedCustomer.push(customer);
    }
    setCustomers(changedCustomer);
    setTotalRecords(changedCustomer);
    setRerendering(true);
  }, []);

  const saveDetails = () => {
    form.submit();
  };

  const getFlag = (short) => {
    const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
    // for dumi
    if (typeof data === "string") {
      return data;
    }
    // for CRA
    return data.default;
  };

  const onFinish = () => {
    const finalCustomers = totalRecords.map((customer) => {
      delete customer.key;
      delete customer.customer.states;
      delete customer.customer.countries;
      delete customer.customer.delivery_countries;
      delete customer.customer.delivery_states;
      customer.customer.name = capital_letter(customer.customer.name.trim());
      customer.customer.city = capital_letter(customer.customer.city);
      customer.customer.delivery_city = capital_letter(customer.customer.delivery_city);
      customer.customer.alias = customer.customer.alias.toUpperCase();
      customer.customer.dealership_date = customer.customer.dealership_date
        ? customer.customer.dealership_date
        : null;
        customer.customer.delivery_state = capital_letter(customer.customer.delivery_state);
        customer.customer.delivery_country = capital_letter(customer.customer.delivery_country);
      return customer;
    });
    const body ={
      file_name: location.state.filename?.split("/").pop() ?? "",
      customers_data: finalCustomers,
      total_customers: finalCustomers.length,
      successful_customers: finalCustomers.length - totalRecords.filter((item) => item.error_count > 0).length
    }
    // console.log(body);
    saveUploadedCustomers(body)
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: "Customers are successfully uploaded",
        });
        showToaster();
        setTimeout(() => {
          history("../customer-records", {
            state: {},
          });
        }, 2000);
        form.resetFields();
      })
      .catch((error) => {
        // setActionToaster({
        //   error: error.response.data.error,
        //   msg: "Customers are not saved",
        // });
        // showToaster();
        if(error?.response?.status == 500){
          setActionToaster({
            error: true,
            msg: "Something went wrong. Please try again",
          });
        } else{
          setActionToaster({
          error: true,
          msg: error.response.data?.msg,
          });
        }
         showToaster();
      });
  };

  const setRowCount = () => {
    rowCount.current = true;
  };

  const validatePrimaryContact = (e, index) => {
    let error = [...primaryContactError];
    if (!e.phone) {
      error[index] = "This field is required";
      setPrimaryContactError(error);
    } else if (!/^\d+$/.test(e.phone)) {
      error[index] = "Only numerical values are accepted";
      setPrimaryContactError(error);
    } else {
      error[index] = "";
      setPrimaryContactError(error);
    }
  };

  const filterRecords = (filterParam) => {
    let failedCustomers = totalRecords.filter((item) =>
      filterParam ? item.error_count > 0 : item
    );
    setCustomers(failedCustomers);
    setRerendering(true);
  };

  useEffect(() => {
    if (rerendering) {
      form.resetFields();
      setRerendering(false);
    }
  }, [rerendering]);
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  const onAliasChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.alias) {
      delete customerData[index].errors.alias;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.alias = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onTypeOfCustomerChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.type) {
      delete customerData[index].errors.type;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.type = e;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onGSTChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.gst_number) {
      delete customerData[index].errors.gst_number;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.gst_number = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onPANChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.pan_number) {
      delete customerData[index].errors.pan_number;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.pan_number = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onDateOfDealershipChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.dealership_date) {
      delete customerData[index].errors.dealership_date;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.dealership_date = e;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onContactPersonChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.person_of_contact) {
      delete customerData[index].errors.person_of_contact;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.person_of_contact = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onContactNumberChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.primary_phone_number) {
      delete customerData[index].errors.primary_phone_number;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.primary_phone_number = e.phone;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onEmailIdChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.primary_email) {
      delete customerData[index].errors.primary_email;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.primary_email = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onFirstDeliveryAddressChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.delivery_address_line_1) {
      delete customerData[index].errors.delivery_address_line_1;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.delivery_address_line_1 = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onSecondDeliverAddressChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.delivery_address_line_2) {
      delete customerData[index].errors.delivery_address_line_2;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.delivery_address_line_2 = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onDeliveryCountryChange = (e, index) => {
    let customerData = [...customers];
    customerData[index].customer.delivery_states = State.getStatesOfCountry(e);
    customerData[index].customer.delivery_state = "";
    if (customerData[index].errors.delivery_country) {
      delete customerData[index].errors.delivery_country;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.delivery_country =
      Country.getCountryByCode(e).name;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onDeliveryStateChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.delivery_state) {
      delete customerData[index].errors.delivery_state;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.delivery_state = e;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onDeliveryCityChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.delivery_city) {
      delete customerData[index].errors.delivery_city;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.delivery_city = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onDeliveryPinChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.delivery_pincode) {
      delete customerData[index].errors.delivery_pincode;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.delivery_pincode = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onFirstAddressChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.address_line_1) {
      delete customerData[index].errors.address_line_1;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.address_line_1 = e.target.value;
    if (customerData[index].customer.same_as_office_address) {
      customerData[index].customer.delivery_address_line_1 = e.target.value;
      form.setFieldsValue({
        [`delivery_address_line_1${index}`]: e.target.value,
      });
    }
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onSecondAddressChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.address_line_2) {
      delete customerData[index].errors.address_line_2;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.address_line_2 = e.target.value;
    if (customerData[index].customer.same_as_office_address) {
      customerData[index].customer.delivery_address_line_2 = e.target.value;
      form.setFieldsValue({
        [`delivery_address_line_2${index}`]: e.target.value,
      });
    }
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onCountryChange = (e, index) => {
    let customerData = [...customers];
    customerData[index].customer.states = State.getStatesOfCountry(e);
    customerData[index].customer.state = "";
    form.setFieldsValue({
      [`state${index}`]: "",
    });

    if (customerData[index].errors.country) {
      delete customerData[index].errors.country;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.country = Country.getCountryByCode(e).name;
    if (customerData[index].customer.same_as_office_address) {
      form.setFieldsValue({
        [`delivery_country${index}`]: Country.getCountryByCode(e).name,
      });
      form.setFieldsValue({
        [`delivery_state${index}`]: "",
      });
      customerData[index].customer.delivery_country =
        Country.getCountryByCode(e).name;
      customerData[index].customer.delivery_states =
        State.getStatesOfCountry(e);
      customerData[index].customer.delivery_state = "";
    }
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onStateChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.state) {
      delete customerData[index].errors.state;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.state = e;
    if (customerData[index].customer.same_as_office_address) {
      customerData[index].customer.delivery_state = e;
      form.setFieldsValue({
        [`delivery_state${index}`]: e,
      });
    }
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onCityChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.city) {
      delete customerData[index].errors.city;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.city = e.target.value;
    if (customerData[index].customer.same_as_office_address) {
      customerData[index].customer.delivery_city = e.target.value;
      form.setFieldsValue({
        [`delivery_city${index}`]: e.target.value,
      });
    }
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onPinChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.pincode) {
      delete customerData[index].errors.pincode;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.pincode = e.target.value;
    if (customerData[index].customer.same_as_office_address) {
      customerData[index].customer.delivery_pincode = e.target.value;
      form.setFieldsValue({
        [`delivery_pincode${index}`]: e.target.value,
      });
    }
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  const onRemarksChange = (e, index) => {
    let customerData = [...customers];

    if (customerData[index].errors.remarks) {
      delete customerData[index].errors.remarks;
      customerData[index].error_count = customerData[index].error_count - 1;
    }
    customerData[index].customer.remarks = e.target.value;
    let totalRecordsData = [...totalRecords];
    let totalCustomerIndex = totalRecordsData.findIndex(function (data, i) {
      return data.key === customerData[index].key;
    });
    totalRecordsData[totalCustomerIndex] = { ...customerData[index] };
    setTotalRecords(totalRecordsData);
    setCustomers(customerData);
  };

  return (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="Upload Result"
          extra={[
            <Button
              key="3"
              className="themeBtn noBg"
              onClick={() => {
                history("../customer-records/upload-customers", {
                  state: { action: customers },
                });
                form.resetFields();
              }}
            >
              <Iconmoon icon="left-to-thin" size={14} color="#EA655B" />
              Upload Again
            </Button>,
            <Button
              key="1"
              className="themeBtn"
              onClick={() => saveDetails()}
              disabled={
                totalRecords.filter((e) => e.error_count > 0).length > 0
              }
            >
              <Iconmoon icon="addcircle" size={14} color="#ffff" />
              Save Customers
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      <div
        className="showPriorityOrder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          flexDirection: "row-reverse",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <DisabledButtonStyle style={{ displayFlex: "end" }}>
              <Button
                className={
                  show
                    ? "themeBtn noBg approveAllOrders"
                    : "themeBtn noBg disabledstyle approve-header"
                }
                onClick={() => {
                  setShow(!show);
                  filterRecords(!show);
                  rowCount.current = false;
                }}
              >
                <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
                {show ? "Show All Customers" : "Show Only Failed Customers"}
              </Button>
            </DisabledButtonStyle>
          </div>
          <div
            style={{
              marginTop: "10px",
              marginRight: "15px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Failed Customers:{" "}
            {totalRecords.filter((e) => e.error_count > 0).length}
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Verified Customers:{" "}
            {totalRecords.filter((e) => e.error_count == 0).length}
          </div>
        </div>
      </div>

      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <div
                style={{
                  overflow: "auto",
                  width: "104%",
                  height: height - 165,
                  position: "relative",
                }}
              >
                {customers.map((input, index) => {
                  return (
                    // (!show || input.error_count > 0) ? (
                    //input.customer.delivery_countries && (
                    <Row
                      gutter={[16, 16]}
                      className="groupForm"
                      style={{
                        width: "2500px",
                        marginBottom: "10px",
                        paddingBottom: "10px",
                      }}
                    >
                      {/* <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
                        {(input.error_count || input.errors.hasOwnProperty(input)) ? (
                          <Iconmoon icon="wrong" size={14} color="#EA655B" />
                        ) : (
                          <div style={{ width: "14px" }}></div>
                        )
                        }
                      </Col> */}
                      <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
                        <Styled>
                          {/* {(input.error_count || input.errors.hasOwnProperty(input)) && */}
                          <Tooltip
                            placement="bottomRight"
                            title={
                              input.error_count ||
                              input.errors.hasOwnProperty(input)
                                ? "This customer has failed validation"
                                : ""
                            }
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                          >
                            <div style={{ cursor: "default" }}>
                              {input.error_count ||
                              input.errors.hasOwnProperty(input) ? (
                                <Iconmoon
                                  icon="wrong"
                                  size={14}
                                  color="#EA655B"
                                />
                              ) : (
                                <div style={{ width: "14px" }}></div>
                              )}
                            </div>
                          </Tooltip>
                          {/* } */}
                        </Styled>
                      </Col>
                      <Col style={{ width: "60px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={
                              index == 0 || !rowCount.current ? "S.No." : ""
                            }
                            name={`sno${index}`}
                            rules={[]}
                            className="dBlock"
                            initialValue={index + 1}
                          >
                            <Input
                              disabled={true}
                              style={{ textTransform: "capitalize" }}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col style={{ width: "170px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "Customer Name" : ""}
                            name={`name${index}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                max: 50,
                                message:
                                  "Name can have a maximum of 50 characters",
                              },
                            ]}
                            className="dBlock"
                            initialValue={input.customer.name}
                          >
                            <Input
                              placeholder="Enter Customer Name"
                              style={{ textTransform: "capitalize" }}
                              disabled
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("name") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.name}
                          </span>
                        ) : null}
                      </Col>
                      <Col style={{ width: "150px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "Customer Alias" : ""}
                            name={`alias${index}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                max: 8,
                                message:
                                  "Alias can have a maximum of 8 characters",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    value == null ||
                                    !aliasList.filter((data) => data.toUpperCase() === value.toUpperCase()).length
                                  ) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(
                                      "This alias exists for another customer"
                                    );
                                  }
                                },
                              },
                            ]}
                            className="dBlock"
                            initialValue={input.customer.alias}
                            // validateStatus={input.errors.hasOwnProperty('product') ? "error" : null}
                            // help={input.errshowSearchsaors.hasOwnProperty('product') ? input.errors.product : null}
                          >
                            <Input
                              placeholder="Enter customer alias"
                              style={{ textTransform: "uppercase" }}
                              onChange={(e) => {
                                onAliasChange(e, index);
                              }}
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("alias") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.alias}
                          </span>
                        ) : null}
                      </Col>
                      <Col style={{ width: "170px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "Type of Customer" : ""}
                            name={`type${index}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="dBlock"
                            initialValue={input.customer.type}
                          >
                            <Select
                              placeholder={"Select"}
                              suffixIcon={<DownArrowDraw />}
                              // defaultValue={userTypeData[0]}
                              onChange={(e) => {
                                onTypeOfCustomerChange(e, index);
                              }}
                            >
                              {userTypeData.map((userType) => (
                                <Option key={userType.value}>
                                  {userType.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("type") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.type}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "170px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "GST" : ""}
                            name={`gst_number${index}`}
                            rules={[
                              {
                                pattern: /^[0-9a-zA-Z]+$/,
                                message: "GST Number is invalid",
                              },
                              {
                                len: 15,
                                message: "GST Number is invalid",
                              },
                            ]}
                            initialValue={input.customer.gst_number}
                            className="dBlock"
                          >
                            <Input
                              onChange={(e) => {
                                onGSTChange(e, index);
                              }}
                              placeholder={"Enter GST Number"}
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("gst_number") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.gst_number}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "170px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "PAN" : ""}
                            name={`pan_number${index}`}
                            rules={[
                              {
                                pattern: /^[0-9a-zA-Z]+$/,
                                message: "PAN Number is invalid",
                              },
                              {
                                len: 10,
                                message: "PAN Number is invalid",
                              },
                            ]}
                            initialValue={input.customer.pan_number}
                            className="dBlock"
                          >
                            <Input
                              onChange={(e) => {
                                onPANChange(e, index);
                              }}
                              placeholder={"Enter PAN Number"}
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("pan_number") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.pan_number}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "170px" }}>
                        <div className="boxFormType">
                          <DatePickerY>
                            <Form.Item
                              label={index == 0 ? "Date of Dealership" : ""}
                              name={`dealership_date${index}`}
                              initialValue={
                                input.customer.dealership_date
                                  ? moment(
                                      input.customer.dealership_date,
                                      "YYYY-MM-DD"
                                    )
                                  : null
                              }
                              className="dBlock"
                            >
                              <DatePicker
                                onChange={(e) => {
                                  onDateOfDealershipChange(e, index);
                                }}
                                format={"DD/MM/YYYY"}
                              />
                            </Form.Item>
                          </DatePickerY>
                        </div>
                        {input.errors.hasOwnProperty("dealership_date") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.dealership_date}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "180px" }}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label={index == 0 ? "Contact Person of Mill" : ""}
                            name={`person_of_contact${index}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                max: 50,
                                message:
                                  "Name can have a maximum of 50 characters",
                              },
                            ]}
                            initialValue={input.customer.person_of_contact}
                            className="dBlock"
                          >
                            <Input
                              placeholder={
                                "Enter the name of the contact person"
                              }
                              onChange={(e) => {
                                onContactPersonChange(e, index);
                              }}
                              style={{ textTransform: "capitalize" }}
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("person_of_contact") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.person_of_contact}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "230px" }}>
                        <div className="boxFormType">
                          <ConfigProvider
                            locale={en}
                            areaMapper={(area) => {
                              return {
                                ...area,
                                emoji: (
                                  <img
                                    alt="flag"
                                    style={{
                                      width: 18,
                                      height: 18,
                                      verticalAlign: "sub",
                                    }}
                                    src={getFlag(area.short)}
                                  />
                                ),
                              };
                            }}
                          >
                            <Form.Item
                              label={index == 0 ? "Primary Contact Number" : ""}
                              name={`primary_phone_number${index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                              className="dBlock"
                              initialValue={{
                                short: input.customer.isoCode,
                                phone: input.customer.primary_phone_number,
                              }}
                            >
                              <CountryPhoneInput
                                style={{ border: "0px solid #605e5c"}}
                                className={`intlPhone ${
                                  primaryContactError ? "showErrorBorder" : ""
                                }`}
                                placeholder={"Enter the contact number"}
                                onChange={(e) => {
                                  onContactNumberChange(e, index);
                                  validatePrimaryContact(e, index);
                                }}
                              />
                            </Form.Item>
                            {primaryContactError[index] ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {primaryContactError[index]}
                              </span>
                            ) : null}
                          </ConfigProvider>
                        </div>
                        {input.errors.hasOwnProperty("primary_phone_number") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.primary_phone_number}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "210px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "Primary Email ID" : ""}
                            name={`primary_email${index}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                type: "email",
                                message: "Email Format is invalid",
                              },
                            ]}
                            initialValue={input.customer.primary_email}
                            className="dBlock"
                          >
                            <Input
                              onChange={(e) => {
                                onEmailIdChange(e, index);
                              }}
                              placeholder={"Enter the email id"}
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("primary_email") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.primary_email}
                          </span>
                        ) : null}
                      </Col>

                      <Col style={{ width: "210px" }}>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={24}>
                            <div className="boxFormType">
                              <Form.Item
                                label="Office Address"
                                name={`address_line_1${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={input?.customer?.address_line_1}
                              >
                                <Input
                                  placeholder={"First Line of address"}
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onFirstAddressChange(e, index);
                                  }}
                                />
                              </Form.Item>
                              {input.errors.hasOwnProperty("address_line_1") ? (
                                <span
                                  className="errorText"
                                  style={{ color: "#ea4e2c" }}
                                >
                                  {input.errors.address_line_1}
                                </span>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={24}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`address_line_2${index}`}
                                rules={[
                                  // {
                                  //   required: true,
                                  //   message: "This field is required",
                                  // },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={input.customer?.address_line_2}
                              >
                                <Input
                                  placeholder={"Second Line of address"}
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onSecondAddressChange(e, index);
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`country${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={
                                  input.customer?.country || undefined
                                }
                              >
                                <Select
                                  className="disabled-check"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  placeholder={"Country"}
                                  onChange={(e) => {
                                    onCountryChange(e, index);
                                  }}
                                >
                                  {input.customer.countries?.map((province) => (
                                    <Option key={province.isoCode}>
                                      {province.name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                            {input.errors.hasOwnProperty("country") ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {input.errors.country}
                              </span>
                            ) : null}
                          </Col>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`state${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={
                                  input.customer?.state || undefined
                                }

                                //   help={
                                //     input.errors.hasOwnProperty("state")
                                //       ? input.errors.state
                                //       : null
                                //   }
                              >
                                <Select
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  placeholder={"State"}
                                  onChange={(e) => {
                                    onStateChange(e, index);
                                  }}
                                >
                                  {input.customer.states?.map((city) => (
                                    <Option key={city.name}>{city.name}</Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                            {input.errors.hasOwnProperty("state") ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {input.errors.state}
                              </span>
                            ) : null}
                          </Col>
                        </Row>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`city${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={input.customer?.city}
                               
                              >
                                <Input
                                  placeholder="City"
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onCityChange(e, index);
                                  }}
                                />
                              </Form.Item>
                            </div>
                            {input.errors.hasOwnProperty("city") ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {input.errors.city}
                              </span>
                            ) : null}
                          </Col>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`pincode${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 10,
                                    message:
                                      "Pincode can have a maximum of 10 characters",
                                  },
                                  {
                                    pattern: new RegExp(/^[0-9]+$/),
                                    message: "Pincode should be a number",
                                  },
                                ]}
                                className=""
                                initialValue={input.customer?.pincode}
                              >
                                <Input
                                  placeholder="Pin Code"
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onPinChange(e, index);
                                  }}
                                />
                              </Form.Item>
                            </div>
                            {input.errors.hasOwnProperty("pincode") ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {input.errors.pincode}
                              </span>
                            ) : null}
                          </Col>
                        </Row>
                      </Col>
                      <Col style={{ width: "210px" }}>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={24}>
                            <div className="boxFormType">
                              <Form.Item
                                label="Delivery Address"
                                name={`delivery_address_line_1${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={
                                  input?.customer?.delivery_address_line_1
                                }
                              >
                                <Input
                                  disabled={
                                    input.customer.same_as_office_address
                                  }
                                  placeholder={"First Line of address"}
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onFirstDeliveryAddressChange(e, index);
                                  }}
                                />
                              </Form.Item>
                              {input.errors.hasOwnProperty("delivery_address_line_1") ? (
                                <span
                                  className="errorText"
                                  style={{ color: "#ea4e2c" }}
                                >
                                  {input.errors.delivery_address_line_1}
                                </span>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={24}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`delivery_address_line_2${index}`}
                                rules={[
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={
                                  input.customer?.delivery_address_line_2
                                }
                              >
                                <Input
                                  disabled={
                                    input.customer.same_as_office_address
                                  }
                                  placeholder={"Second Line of address"}
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onSecondDeliverAddressChange(e, index);
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`delivery_country${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={
                                  input.customer?.delivery_country || undefined
                                }
                              >
                                <Select
                                  className="disabled-check"
                                  suffixIcon={<DownArrowDraw />}
                                  disabled={
                                    input.customer.same_as_office_address
                                  }
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  placeholder="Country"
                                  onChange={(e) => {
                                    onDeliveryCountryChange(e, index);
                                  }}
                                  //onChange={handleProvinceChange}
                                >
                                  {input.customer.countries?.map((province) => (
                                    <Option key={province.isoCode}>
                                      {province.name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                            {input.errors.hasOwnProperty("delivery_country") ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {input.errors.delivery_country}
                              </span>
                            ) : null}
                          </Col>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`delivery_state${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={
                                  input.customer?.delivery_state || undefined
                                }
                                validateStatus={
                                  input.errors.hasOwnProperty("delivery_state")
                                    ? "error"
                                    : null
                                }
                                help={
                                  input.errors.hasOwnProperty("delivery_state")
                                    ? input.errors.delivery_state
                                    : null
                                }
                              >
                                <Select
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  placeholder={"State"}
                                  disabled={
                                    input.customer.same_as_office_address
                                  }
                                  onChange={(e) => {
                                    onDeliveryStateChange(e, index);
                                  }}
                                >
                                  {input.customer.delivery_states?.map(
                                    (city) => (
                                      <Option key={city.name}>
                                        {city.name}
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`delivery_city${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 50,
                                    message:
                                      "Name can have a maximum of 50 characters",
                                  },
                                ]}
                                className=""
                                initialValue={input.customer?.delivery_city}
                                validateStatus={
                                  input.errors.hasOwnProperty("delivery_city")
                                    ? "error"
                                    : null
                                }
                                help={
                                  input.errors.hasOwnProperty("delivery_city")
                                    ? input.errors.delivery_city
                                    : null
                                }
                              >
                                <Input
                                  disabled={
                                    input.customer.same_as_office_address
                                  }
                                  placeholder="City"
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onDeliveryCityChange(e, index);
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div className="boxFormType">
                              <Form.Item
                                name={`delivery_pincode${index}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    max: 10,
                                    message:
                                      "Pincode can have a maximum of 10 characters",
                                  },
                                  {
                                    pattern: new RegExp(/^[0-9]+$/),
                                    message: "Pincode should be a number",
                                  },
                                ]}
                                className=""
                                initialValue={input.customer?.delivery_pincode}
                              >
                                <Input
                                  disabled={
                                    input.customer.same_as_office_address
                                  }
                                  placeholder="Pin Code"
                                  style={{ textTransform: "capitalize" }}
                                  onChange={(e) => {
                                    onDeliveryPinChange(e, index);
                                  }}
                                />
                              </Form.Item>
                            </div>
                            {input.errors.hasOwnProperty("delivery_pincode") ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {input.errors.delivery_pincode}
                              </span>
                            ) : null}
                          </Col>
                        </Row>
                      </Col>
                      <Col style={{ width: "210px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            label={index == 0 ? "Remarks" : ""}
                            name={`remarks${index}`}
                            rules={[
                              {
                                max: 70,
                                message:
                                  "Remarks can have a maximum of 70 characters",
                              },
                            ]}
                            initialValue={input.customer.remarks}
                            className="dBlock"
                          >
                            <TextArea
                              onChange={(e) => {
                                onRemarksChange(e, index);
                              }}
                              style={{ height: "40px" }}
                            />
                          </Form.Item>
                        </div>
                        {input.errors.hasOwnProperty("remarks") ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            {input.errors.remarks}
                          </span>
                        ) : null}
                      </Col>
                      {setRowCount()}
                    </Row>
                  );
                  // ) : null
                  //  );
                })}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {/* Toasters */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  );
};

export default CustomerValidation;
